import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ServantList from './ServantList';
import PositionManagement from './PositionManagement';
import './ServePositionManager.css';

const ServePositionManager = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('servants');

  return (
    <div className="serve-position-manager">
      <div className="page-header">
        <h1 className="page-title">事奉崗位管理</h1>
        <p className="page-description">管理教會的事奉崗位和同工分配</p>
      </div>

      <div className="tabs-container">
        <div className="tabs">
          <button
            className={`tab ${activeTab === 'servants' ? 'active' : ''}`}
            onClick={() => setActiveTab('servants')}
          >
            <span>事奉分配名單</span>
          </button>
          <button
            className={`tab ${activeTab === 'positions' ? 'active' : ''}`}
            onClick={() => setActiveTab('positions')}
          >
            <span>崗位管理</span>
          </button>
        </div>
      </div>

      <div className="tab-content">
        {activeTab === 'servants' && <ServantList />}
        {activeTab === 'positions' && <PositionManagement />}
      </div>
    </div>
  );
};

export default ServePositionManager;
